import { GetPosParams } from "@bvhi/backend-api/apis/model/getPosParams";
import { PosSortByParam } from "@bvhi/backend-api/apis/model/posSortByParam";
import { PosSortParameter } from "@bvhi/backend-api/apis/model/posSortParameter";
import { createFileRoute } from "@tanstack/react-router";
import { WithErrorBoundary } from "../../../hoc/with-error-boundary";
import { withPermissionCheck } from "../../../hoc/with-permission-check";
import { PosListView } from "../../../views/app/pointofsale/list/pos-list-view";

export const Route = createFileRoute("/_main/app/pos/")({
  validateSearch: (search: Record<string, unknown>): GetPosParams => {
    return {
      page: Number(search?.page ?? 0),
      size: Number(search?.size ?? 25),
      sort: (search?.sort as PosSortParameter) || [PosSortByParam.NAME_ASC],
    };
  },
  component: () =>
    WithErrorBoundary({
      Component: withPermissionCheck({ Component: PosListView }),
    }),
});
